import { Typography } from '@mui/material';
import { CSSProperties, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { SummaryItem } from '~/components/MyWorkspace/SummaryItem';
import { Employees } from '~/data/employees/types';
import { getProfilePictureUrl } from '~/utils/helper';

import { useSxStyles } from './useStyles';

type PropsType = {
  employee: Employees;
  showNew?: boolean;
  handleClick: (id: number, unitId: number) => void;
  showEmpNumber?: boolean;
  style?: CSSProperties;
};

export const SearchedItem = (props: PropsType) => {
  const { employee, showNew, handleClick, showEmpNumber, style } = props;

  const { t } = useTranslation();
  const sxStyles = useSxStyles();
  const onClick = useCallback(() => {
    handleClick(employee.fEmpId, employee.fEmpUnit);
  }, [employee, handleClick]);

  return (
    <SummaryItem
      style={style}
      avatarProps={{
        src: getProfilePictureUrl(employee.fEmpProfPictureId),
      }}
      listItemProps={{
        disableGutters: true,
      }}
      customSxStyles={{
        listItemRoot: sxStyles.listItemRoot,
      }}
      primaryElement={
        <>
          <Typography
            variant="body1"
            noWrap={true}
            lineHeight={1}
            sx={sxStyles.primaryElement}
          >
            {`${employee.fEmpLastName}, ${employee.fEmpFirstName}`}
          </Typography>
          {showNew && employee.fEmpStatus === 'NEW' && (
            <Typography
              variant="body2"
              sx={{ ...sxStyles.primaryElement, ...sxStyles.statusNew }}
            >
              {t('laNew')}
            </Typography>
          )}
        </>
      }
      secondaryElement={
        <div>
          <Typography
            variant="body2"
            lineHeight={1.1}
            sx={sxStyles.secondaryElement}
          >
            {employee.fEmpPosition}
          </Typography>
          {showEmpNumber ? (
            <Typography
              variant="body2"
              lineHeight={1.1}
              sx={sxStyles.secondaryElement}
            >
              {employee.fEmpPersonNumber}
            </Typography>
          ) : null}
        </div>
      }
      onClick={onClick}
    />
  );
};
